<script lang="ts">
    import {
        COMMON__Home,
        DICTIONARY__hide,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { fade, slide } from "svelte/transition";
    import {
        addFloatingMessage,
        removeFloatingMessage,
        type FloatingMessageWithId,
    } from "./FloatingMessages.controller";

    const HIDE_MESSAGE_TIMEOUT = 10 * 1000;
    export let message: FloatingMessageWithId;
    export let onClose = () => {};
    let classNames: string = "";
    switch (message.type) {
        /*
        case "error": {
            classNames = "bg-red-50 border-red-700 text-red-700";
            break;
        }
        case "warn": {
            classNames = "bg-secondary-50 border-yellow-700 text-gray-900";
            break;
        }*/
        default:
            classNames = "text-white";
    }

    function onCloseLocal() {
        onClose();
        removeFloatingMessage(message);
    }

    setTimeout(() => {
        onCloseLocal();
    }, HIDE_MESSAGE_TIMEOUT);
</script>

<div
    class="bg-slate-600 rounded shadow-lg border-gray-300 border mb-2 w-full"
    in:fade
    out:slide
>
    <div class="p-2 rounded text-sm {classNames} flex flex-wrap">
        <h1 class="text-md font-medium h-10 flex items-center flex-1">
            {message.title}
        </h1>
        <div class="w-1" />
        <div class="dir-aware-text-right py-1">
            {#each message.actions as action}
                {#if action.callback}
                    <button
                        class="button-sm"
                        class:button-primary={action.primary}
                        on:click={() => {
                            onCloseLocal();
                            action.callback();
                        }}>{action.text}</button
                    >
                {/if}
                {#if action.linkUrl}
                    <a
                        href={action.linkUrl}
                        class="button-sm"
                        class:button-primary={action.primary}
                        target="_blank">{action.text}</a
                    >
                {/if}
            {/each}
            {#if !message.actions || message.actions.length === 0}
                <button
                    class="button-sm"
                    class:button-primary={true}
                    on:click={onCloseLocal}
                >
                    {getMessage(DICTIONARY__hide)}</button
                >
            {/if}
        </div>
    </div>
</div>
